export const useDefaultData = () => {

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFormPermissions = {
        idpermiso: '',
        idpermiso_padre: '',
        nombrepermisos: '',
        estado: '',
        permissionsChild: []
    }

    return Object.freeze({
        defaultDataModal,
        defaultFormPermissions
    })
}